"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FeedPromoItem", {
  enumerable: true,
  get: function get() {
    return _PromoItem["default"];
  }
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactSpring = require("react-spring");
var _classnames = _interopRequireDefault(require("classnames"));
var _PromoItem = _interopRequireDefault(require("./PromoItem"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MIN_HEIGHT = 500;
var ThreadFeedItem = function ThreadFeedItem(_ref) {
  var dndRef = _ref.dndRef,
    avatar = _ref.avatar,
    fromName = _ref.fromName,
    fromAddress = _ref.fromAddress,
    title = _ref.title,
    body = _ref.body,
    receivedAt = _ref.receivedAt,
    actions = _ref.actions,
    _onClick = _ref.onClick,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$readStatus = _ref.readStatus,
    readStatus = _ref$readStatus === void 0 ? false : _ref$readStatus;
  function handleEventPropagation(e) {
    e.stopPropagation();
  }
  return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    className: "relative overflow-hidden m-2 rounded-lg bg-card cursor-pointer",
    style: {
      boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 30px'
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick();
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: dndRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-5 pt-6 mb-4 cursor-pointer select-none"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex items-center mb-4', {
      'text-light': readStatus
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center w-12 h-12 ml-1 mr-5",
    onClick: handleEventPropagation
  }, avatar), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 mx-4 min-w-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex items-center', {
      'text-dark': !readStatus
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "truncate font-bold"
  }, fromName), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('ml-4 text-sm flex-shrink-0', {
      'text-gray-medium': !readStatus
    })
  }, receivedAt)), fromName !== fromAddress && /*#__PURE__*/_react["default"].createElement("div", {
    className: "truncate"
  }, fromAddress)), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleEventPropagation
  }, actions)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('font-bold truncate', {
      'text-dark': !readStatus,
      'text-light': readStatus
    })
  }, title))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2 mx-auto pointer-events-none select-none",
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: style.width * 0.9,
      minHeight: MIN_HEIGHT
    })
  }, body), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative h-8 bg-app dark:bg-secondary z-10"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      bottom: '100%'
    },
    className: "absolute w-full h-14 gradient secondary-gradient bg-gradient-b"
  })));
};
var _default = exports["default"] = ThreadFeedItem;
//# sourceMappingURL=index.js.map